export default "__VITE_ASSET__CdRhb_MI__"